import React, { Component } from 'react'
import { Button, Drawer, Form } from 'antd';
import Swal from "sweetalert2";

class ShiftAdd extends Component {
    constructor() {
        super();
        this.state = {
            sift_name: '',
            sift_late_tolerance: '',
            loading: false
        }
    }
    handleSubmit = () => {
        this.setState({
            loading: true
        })
        let form = {
            sift_name: this.state.sift_name,
            sift_late_tolerance: this.state.sift_late_tolerance,
        }

        this.props.request("shift/add", form, 'POST')
            .then(response => {
                if (response.success) {
                    const filter_data = JSON.parse(localStorage.getItem('Presensi-Company-Data'))
                    if (filter_data && filter_data._sift) {
                        filter_data._sift.push({
                            sift_id             : response.data.sift_id,
                            perusahaan_id       : response.data.perusahaan_id,
                            sift_name           : response.data.sift_name,
                            sift_late_tolerance : response.data.sift_late_tolerance,
                            sift_status         : response.data.sift_status,
                            sift_create_date    : response.data.sift_create_date
                        });
                        localStorage.setItem('Presensi-Company-Data', JSON.stringify(filter_data));
                    }
                    this.setState({ sift_name: '', sift_late_tolerance: '' })
                    this.props.changeState({
                        sift_name: '',
                        sift_late_tolerance: '',
                        add_visible: false,
                        data: [],
                        isLoading: true,
                    }, () => {
                        this.props.loadData()
                        this.props.loadCheck()
                    })
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false
                })
            });
    }

    render() {
        return (
            <Drawer
                title="Tambah Sift"
                width={350}
                onClose={() => {
                    this.props.changeState({ add_visible: false, divisi_name: '' });
                }}
                visible={this.props.add_visible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={() => {
                            this.props.changeState({ add_visible: false, sift_name: '' });
                        }}
                            style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.handleSubmit} disabled={this.state.loading} type="primary">
                            {this.state.loading ?
                                <><i className={"fa fa-refresh fa-spin"}></i> Loading</>
                                :
                                "Simpan"
                            }
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Nama Shift</label>
                        <input name="sift_name" className="form-control col-xl-12 col-md-12" placeholder="Sift..."
                            type="text" required="" value={this.state.sift_name}
                            onChange={(event) => {
                                const target = event.target;
                                const value = target.value;
                                const name = target.name;
                                this.setState({
                                    [name]: value
                                });
                            }} />
                    </div>
                    <div className="form-group">
                        <label>Toleransi Terlambat (menit)</label>
                        <input name="sift_late_tolerance" className="form-control col-xl-12 col-md-12" placeholder="Durasi Toleransi Waktu..."
                            type="number" required value={this.state.sift_late_tolerance}
                            onChange={(event) => {
                                const target = event.target;
                                const value = target.value;
                                const name = target.name;
                                this.setState({
                                    [name]: value
                                });
                            }} />
                    </div>
                </Form>
            </Drawer>

        )
    }
}

export default ShiftAdd
